import { Box, Button, Flex } from '@chakra-ui/react'
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons'

import Icon from 'src/components/widgets/Icon/Icon'
import { chakraColorToCSSVariable } from 'src/lib/utils'

const BrandColorButton: React.FC<{
  brandColor: string
  onClick: React.MouseEventHandler
}> = ({ brandColor, onClick }) => {
  const brandColorAsCSSVariable = chakraColorToCSSVariable(brandColor)
  return (
    <Button
      bg={`linear-gradient(266.57deg, rgba(255, 255, 255, 0.2) -0.42%, rgba(255, 255, 255, 0) 100%), ${brandColorAsCSSVariable}`}
      boxShadow="sm"
      borderRadius="16px"
      px={5}
      py={4}
      color="white"
      w="100%"
      onClick={onClick}
      _hover={{
        bg: `linear-gradient(266.57deg, rgba(255, 255, 255, 0.3) -0.42%, rgba(255, 255, 255, 0) 100%), ${brandColorAsCSSVariable}`,
      }}
      _active={{
        bg: `linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(266.57deg, rgba(255, 255, 255, 0.2) -0.42%, rgba(255, 255, 255, 0) 100%), ${brandColorAsCSSVariable}`,
      }}
    >
      <Flex alignItems="center" textAlign="left" w="100%">
        <Box flexGrow={1}>
          <h5 className="thick">What&apos;s an ItList?</h5>
          <Box className="body-small">Watch the walkthrough.</Box>
        </Box>
        <Icon ml={2} icon={faCirclePlay} fontSize="31px" />
      </Flex>
    </Button>
  )
}

export default BrandColorButton
